import t from './DPP.type';
import * as dppService from '../../../../services/dpp.services';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';

export const addDPPLibrary = (payload, transactionMsg) => async () => {
  try {
    const res = await dppService.insertDPPLibrary(payload);
    if (res?.code === 200) {
      const msg = transactionMsg(`DPP.ACTION.${res?.message}`);
      toasterMsg(msg, 'success');
      return res;
    }

    const msg = transactionMsg(`DPP.ACTION.${res.data?.errMsg}`);
    toasterMsg(msg.toString(), 'danger');
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getDPPLibData = (dppId) => async (dispatch) => {
  try {
    const res = await dppService.getDPPLibraryById(dppId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_DPP_DATA_BYID,
        payload: res?.data ? res.data : [],
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getAllDPPLibrary = () => async (dispatch) => {
  try {
    const res = await dppService.getAllDPPLibrary();
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_ALL_DPP_LIST,
        payload: res?.data ? res.data : [],
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const UNMOUNT_LIBRARY_LIST = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.UNMOUNT_DPP_LIST,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const unmountDPPLibrary = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.UNMOUNT_DPP_LIBRARY,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updateDPPLibrary = (payload, dppId, transactionMsg) => async () => {
  try {
    const res = await dppService.editDPPLibraryById(payload, dppId);
    if (res?.code === 200) {
      const msg = transactionMsg(`DPP.ACTION.${res?.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    const msg = transactionMsg(`DPP.ACTION.${res.data?.errMsg}`);
    toasterMsg(msg.toString(), 'danger');
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const uploadDPPImage = (data) => async () => {
  try {
    const res = await dppService.uploadDPPImageS3(data);
    if (res?.code === 200) {
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getMetaDataforURL = (data, transactionMsg) => async () => {
  try {
    const res = await dppService.getMetaDataURL(data);
    if (res?.code === 200) {
      return res;
    }
    const msg = transactionMsg(`DPP.ACTION.${res.data?.errMsg}`);
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteDPPLibrary = (data, transactionMsg) => async () => {
  try {
    const res = await dppService.deleteDPPLibrary(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`DPP.ACTION.${res?.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    const msg = transactionMsg(`DPP.ACTION.${res.data?.errMsg}`);
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getGoogleMapDetails = (data) => async () => {
  try {
    const res = await dppService.getGoogleMapDetails(data);
    if (res?.code === 200) {
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getGoogleMapPlaceAutocomplete = (data) => async () => {
  try {
    const res = await dppService.getGoogleMapPlaceAutocomplete(data);
    if (res?.status === 'OK') {
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getGoogleMapPlaceDetails = (data) => async () => {
  try {
    const res = await dppService.getGoogleMapPlaceDetails(data);
    if (res?.status === 'OK') {
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getGoogleMapPlaceNearby = (data) => async () => {
  try {
    const res = await dppService.getGoogleMapPlaceNearby(data);
    if (res?.status === 'OK') {
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
